var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpRaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4962_574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9999 2V7.99854H41.8792V2H42.9999Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6213 6.45499L37.1654 8H36L37.9549 2.00146H39.3038L41.25 8H40.0249L39.5675 6.45799H37.6213V6.45499ZM39.3376 5.57322L38.6238 3.14771H38.5742L37.8605 5.57322H39.3376Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625V32.3438V39C0 42.3137 2.68629 45 6 45H38.5096C40.231 45 41.8818 44.4074 43.099 43.3525C44.3162 42.2976 45 40.8668 45 39.375V10H41.7548H36C34.8954 10 34 9.10457 34 8V0H6.49038C4.76903 0 3.11818 0.592632 1.90099 1.64753C0.683811 2.70242 0 4.13316 0 5.625Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.056 13.864C16.48 13.864 17.648 14.048 18.56 14.416C19.488 14.768 20.176 15.304 20.624 16.024C21.072 16.744 21.296 17.648 21.296 18.736C21.296 19.648 21.128 20.408 20.792 21.016C20.456 21.624 20.024 22.112 19.496 22.48C18.984 22.832 18.44 23.112 17.864 23.32L22.568 31H20.048L15.896 23.92H12.488V31H10.328V13.864H15.056ZM14.936 15.736H12.488V22.096H15.056C15.984 22.096 16.744 21.976 17.336 21.736C17.928 21.48 18.36 21.112 18.632 20.632C18.92 20.152 19.064 19.552 19.064 18.832C19.064 18.08 18.912 17.48 18.608 17.032C18.32 16.584 17.872 16.256 17.264 16.048C16.656 15.84 15.88 15.736 14.936 15.736ZM36.0097 31L33.9457 25.696H27.1537L25.1137 31H22.9297L29.6257 13.792H31.5697L38.2417 31H36.0097ZM31.3777 18.592C31.3297 18.464 31.2497 18.232 31.1377 17.896C31.0257 17.56 30.9137 17.216 30.8017 16.864C30.7057 16.496 30.6257 16.216 30.5617 16.024C30.4817 16.344 30.3937 16.672 30.2977 17.008C30.2177 17.328 30.1297 17.624 30.0337 17.896C29.9537 18.168 29.8817 18.4 29.8177 18.592L27.8737 23.776H33.2977L31.3777 18.592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4962_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpRaLogo);
export default __webpack_public_path__ + "static/media/SP_RA_Logo.daa45941bae7aacd13fc0d6d42bd4fa2.svg";
export { ForwardRef as ReactComponent };